export enum GameDataSource {
  Club,
  ExternalRef,
  MemberId
}
